import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const FlexChildren = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const container_style = {
  height: '100%'
};
